class CountOnGrid extends HTMLElement {
  constructor() {
    super();
    this.count = 0;
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener(
      'update:infinite:product-grid',
      this.updateCount.bind(this),
    );
  }

  updateCount(event) {
    if (event.detail && event.detail.count !== undefined) {
      this.innerHTML = event.detail.count;
    } else {
      console.warn('CountOnGrid: No count data received in event');
    }
  }
}

customElements.define('count-on-grid', CountOnGrid);
